module.exports = __webpack_public_path__ + "static/img/score-pc-2.f274188c.png";